<template>
	<select class="form-control serenity__select-input">
		<slot></slot>
	</select>
</template>

<script>
export default {
	props: {},
};
</script>

<style lang="scss">
.serenity__select-input {
	height: 50px;
	background: #f8f9f8;
	border: 1px solid #f2f2f2;
	box-sizing: border-box;
	border-radius: 5px;
	padding-left: 20px;
	padding-right: 20px;
	color: #26354c;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 140%;

	&:focus {
		outline: 0;
		background: #ffffff;
		color: #26354c;
		border: 1px solid #28aead;
		box-sizing: border-box;
		border-radius: 5px;
		box-shadow: none;
	}
}
</style>
